import { Button } from "@svea/design-system-components-react";
import { formatSniCode } from "../../utils";
import { SmallCard } from "../small-card";
import { Stack } from "../stack";
import { P } from "../typography";

type Props = {
	sniCode: string;
	description: string;
	onDelete: (code: string) => void;
};

export const SniCodeItem: React.FC<Props> = ({ sniCode, description, onDelete }: Props) => (
	<SmallCard key={sniCode} className="bg-background-secondary">
		<Stack direction="row" gap={2}>
			<Stack>
				<P bold>{formatSniCode(sniCode)}</P>
				<P>{description}</P>
			</Stack>
			<Button
				variant="icon"
				onPress={() => {
					onDelete(sniCode);
				}}
				icon="trash"
				aria-label="Ta bort"
				data-testid="deleteSniCode"
			/>
		</Stack>
	</SmallCard>
);
